// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form___cl0f","signatureButtonsRight":"ModalSign_signatureButtonsRight___Jlha"};